export const APP_NAMES = Object.freeze({
  CONSUMER: "homehelper_consumer",
  CONTRACTOR: "homehelper_contractor",
});

export const APP_NAME = APP_NAMES.CONSUMER;

export const USER_TYPES = Object.freeze({
  HOMEOWNER: "homeowner",
  CONTRACTOR: "contractor",
});

export const DEFAULT_USER_TYPE = USER_TYPES.HOMEOWNER;

export const PAGE_TYPES = Object.freeze({
  HOME: "home",
  CATEGORY_LANDING: "category_landing",
  ZIP_LANDING: "zip_landing",
  SURVEY: "survey",
  SURVEY_COMPLETE: "survey_complete",
  REPORT: "report",
  PROVIDER_LIST: "provider_list",
  PROVIDERS_DIRECTORY: "providers_directory",
  PROVIDER_PROFILE: "provider_profile",
  TOOL: "tool",
  CAMPAIGN: "campaign",
  FAQ: "faq",
  LEGAL: "legal",
  OTHER: "other",
});

export const EVENT_NAMES = Object.freeze({
  PAGE_VIEW: "page_view",
  VIEW_HOME: "view_home",
  VIEW_CATEGORY_LANDING: "view_category_landing",
  VIEW_ZIP_LANDING: "view_zip_landing",
  CTA_CLICK: "cta_click",
  SURVEY_START: "survey_start",
  VIEW_SURVEY_STEP: "view_survey_step",
  SURVEY_QUESTION_ANSWERED: "survey_question_answered",
  SURVEY_QUESTION_SKIPPED: "survey_question_skipped",
  SURVEY_BACK_CLICKED: "survey_back_clicked",
  SURVEY_ABANDON: "survey_abandon",
  SURVEY_STEP_COMPLETED: "survey_step_completed",
  SURVEY_COMPLETE: "survey_complete",
  LEAD_SUBMIT_ATTEMPT: "lead_submit_attempt",
  LEAD_SUBMIT_SUCCESS: "lead_submit_success",
  LEAD_PHOTO_UPLOAD: "lead_photo_upload",
  LEAD_PHOTO_UPLOAD_SUCCESS: "lead_photo_upload_success",
  AI_REPORT_GENERATE_STARTED: "ai_report_generate_started",
  AI_REPORT_GENERATE_CLICKED: "ai_report_generate_clicked",
  AI_REPORT_GENERATED: "ai_report_generated",
  FEATURED_CONTRACTOR_CLICK: "featured_contractor_click",
  BROWSE_PROVIDERS_CLICK: "browse_providers_click",
  PROVIDER_CARD_CLICK: "provider_card_click",
  LATEST_REPORT_BADGE_CLICKED: "latest_report_badge_clicked",
  REPORT_VIEWED: "report_viewed",
  CAMPAIGN_VISIT: "campaign_visit",
});

export const PARAM_KEYS = Object.freeze({
  APP_NAME: "app_name",
  USER_TYPE: "user_type",
  PAGE_TYPE: "page_type",
  CATEGORY_KEY: "category_key",
  ZIP_CODE: "zip_code",
  CITY: "city",
  STATE: "state",
  LEAD_ID: "lead_id",
  PROVIDER_ID: "provider_id",
  PROJECT_GUID: "project_guid",
  SURVEY_ID: "survey_id",
  QUESTION_ID: "question_id",
  QUESTION_TYPE: "question_type",
  ANSWER_VALUE: "answer_value",
  STEP_INDEX: "step_index",
  STEP_NAME: "step_name",
  CTA_NAME: "cta_name",
  PLACEMENT: "placement",
  TIER: "tier",
  MONTHLY_PRICE: "monthly_price",
  CART_VALUE: "cart_value",
  SUBSCRIPTION_COUNT: "subscription_count",
  RESULT_COUNT: "result_count",
  SEARCH_RADIUS_MILES: "search_radius_miles",
  PHOTO_COUNT: "photo_count",
  ZIP_CODES: "zip_codes",
  CATEGORY_KEYS: "category_keys",
  FILTER_NAME: "filter_name",
  FILTER_VALUE: "filter_value",
  SORT_OPTION: "sort_option",
  STATUS: "status",
  PREVIEW_AVAILABLE: "preview_available",
  ERROR_TYPE: "error_type",
  CHECKOUT_STAGE: "checkout_stage",
  IS_LOGGED_IN: "is_logged_in",
  HAS_PHOTOS: "has_photos",
  REPORT_TYPE: "report_type",
  CAMPAIGN_ID: "campaign_id",
});
